import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";



// Custom Components
import Filter from "@Components/Filter";
import Table from "@Components/Table";
import {
  BLOCK_FETCH_URL,
  COMPANY_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  LIST_SUPERVISOR_URL,
  REGION_FETCH_URL,
  ZONE_FETCH_URL,
} from "../../configs/constants";
import { fetchDataFromApi } from "../../utils";

const today = new Date();
const options = { timeZone: 'Asia/Kuala_Lumpur' };
let date = today.toLocaleDateString('en-GB', options);
date = date.split('/').reverse().join('-');
const pageNumberDropdown = true;


let model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "supervisor_name_id", label: "Supervisor", type: "string" },
  { id: "mobile_number", label: "Mobile Number", type: "string" },
  { id: "estate", label: "Estate", type: "string" },
  { id: "attendance_date", label: "Date", type: "date" },
  { id: "check_in_time", label: "Today Clock In Time", type: "string" },
  { id: "check_out_time", label: "Today Clock Out Time", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "remarks", label: "Type of Attendance", type: "string" },
];

const status = [
  {
    id: "Absent",
    name: "Absent",
  },
  {
    id: "Present",
    name: "Present",
  },
  {
    id: "pending_clock_in",
    name: "Pending Clock In",
  },
  {
    id: "pending_clock_out",
    name: "Pending Clock Out",
  },
];
const validationSchema = Yup.object({
  from_date: Yup.date().required("Date is required").nullable().typeError("Invalid Attended Date"),
  to_date: Yup.date().required("Date is required").nullable().typeError("Invalid Attended Date"),
 });

 const getCompanyValues = (e, setDisableZone) => {
  if (!e || e.length === 0) {
    setDisableZone(true);
  }
  else {
    setDisableZone(false);
  }

};

const getZoneValues = (e, setDisableRegion) => {
  if (!e || e.length === 0 || e.label == "N/A") {
    setDisableRegion(true);
  }
  else {
    setDisableRegion(false);
  }

};
const getRegionValues = (e, setDisableEstate) => {
  if (!e || e.length === 0) {
    setDisableEstate(true);
  }
  else {
    setDisableEstate(false);
  }

};

const getEstateValues = (e, setDisableDivision) => {
  if (!e || e.length === 0) {
    setDisableDivision(true);
  }
  else {
    setDisableDivision(false);
  }

};
const getDivisonValues = (e, setDisableBlock) => {
  if (!e || e.length === 0) {
    setDisableBlock(true);
  }
  else {
    setDisableBlock(false);
  }

};
export default function AttendanceRecord() {
  const [supervisor, setSupervisor] = useState(null);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const [disableZone, setDisableZone] = useState(true);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [filtersApplied, setFiltersApplied] = useState(false);

  useEffect(() => {
    fetchDataFromApi(LIST_SUPERVISOR_URL, setSupervisor, false);
  }, []);
  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };
  const filterFields = [
    {
      type: "datepicker",
      label: "From Date",
      name: "from_date",
      maxDate: selectedtoDate,
      getValue: getFormDate,
      required: true

    },
    {
      type: "datepicker",
      label: "To Date",
      name: "to_date",
      minDate: selectedFormDate,
      getValue: getToDate,
      required: true

    },
    {
      type: "reactselect",
      label: "Status",
      name: "status",
      outerOptions: status,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,


    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled: disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled: disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled: disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled: disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled: disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "input",
      label: "Worker ID",
      name: "employee_id",
    },
    {
      type: "input",
      label: "Worker Name",
      name: "name",
    },
    {
      type: "reactselect",
      label: "Supervisor",
      name: "supervisor_id",
      outerOptions: supervisor,
    },
  ];
  const details = useLocation();
  const filterInitialValues = {
    from_date: details?.searchParams?.from_date?.dateForAPI || date,
    to_date: details?.searchParams?.to_date?.dateForAPI || date,
    status: details?.searchParams?.status || null,
    zone_id: "",
    region_id: "",
    estate_id: "",
    block_id: "",
    supervisor_id: "",
    employee_id: "",
    name: "",
  };
  let filters = {};
  if ("searchParams" in details) {
    if (details.searchParams.from_date.dateForAPI) {
      filters["from_date"] = details.searchParams.from_date.dateForAPI;
    }
    if (details.searchParams.to_date.dateForAPI) {
      filters["to_date"] = details.searchParams.to_date.dateForAPI;
    }
    if (details.searchParams.status) {
      filters["status"] = details.searchParams.status;
    }
  }
  const [filterValues, setFilterValues] = useState(filters);
  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    //filterObj.status = null
    setFilterValues(filterObj);
  };
  const clearFilter = () => {
    filterInitialValues.status = null
    location.reload();
  }

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}
        validationSchema={validationSchema}

      />
  {filtersApplied ? (

      <Table
        proxyURL="attendance/"
        model={model}
        emailExcelExport={{ fileName: "AttendanceRecord" }}
        filterValues={filterValues}
        noFilter
        isBackOffice
        pageNumberDropdown={pageNumberDropdown}

      />
      ) : (
        <Table
        proxyURL={null}
        model={model}
        emailExcelExport={{ fileName: "AttendanceRecord" }}
        filterValues={filterValues}
        noFilter
        isBackOffice
        pageNumberDropdown={pageNumberDropdown}

      />
      )}   

    </div>
  );
}
